.bf{right:0px;}